const FieldChangeSources = {
  DocumentIntelligence: 1,
  DocumentModal: 2,
  MultipleDocumentEdition: 3,
  1: 'DocumentIntelligence',
  2: 'DocumentModal',
  3: 'MultipleDocumentEdition',
};
export default FieldChangeSources;
